<template>
    <div class="d-flex w-100">
        <v-text-field
          @input="setSearchName"
          :value="searchName"
          append-icon="mdi-magnify"
          label="Rechercher"
          clearable
          outlined
          hide-details
          class="w-100 pb-2"
        ></v-text-field>

        <div v-for="family in criteriaFamilies" class="w-100 mx-2">
            <v-select
              :label="family.label"
              outlined
              chips
              small-chips
              v-model="cadhCriteriasFilter"
              :items="family.criterias"
              item-text="label"
              item-value="id"
              hide-details
              deletable-chips
              multiple
              clearable
              no-data-text="Aucune donnée disponible"
            ></v-select>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "EditCadhConfigFilters",
    data() {
        return {}
    },
    methods: {
        ...mapMutations("cadhConfig", ["setSearchName", "setCriteriasFilter"]),
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "searchName", "criteriaFamilies", "criteriasFilter"]),
        cadhCriteriasFilter: {
            get() {
                return this.criteriasFilter
            },
            set(value) {
              this.$store.commit('cadhConfig/setCriteriasFilter', value)
            }
        }
    },
}
</script>